import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Collapse, List, ListItem } from '@mui/material';
import React, { useState } from 'react';
import { BasketListViewModel } from '../../models/BasketListViewModel';
import { SidebarList } from '../../models/SidebarList';
import { StyledNormalTypography } from '../../theme/StyledElements';
import { InsideMultiLevel } from './InsideMultiLevel';

interface MultiLevelProps {
    item: SidebarList;
    active: string;
    setActive: Function;
}

export const MultiLevel = ({ item, active, setActive }: MultiLevelProps): JSX.Element => {
    const { items: children } = item;
    const [open, setOpen] = useState(true);

    const handleClick = (): void => {
        setOpen((prev) => !prev);
    };

    return (
        <>
            <ListItem
                button
                onClick={handleClick}
                sx={{
                    backgroundColor: '#394A35',
                    '&:hover': {
                        backgroundColor: '#394A35',
                        color: '#FFFFFF'
                    },
                    justifyContent: 'space-between',
                    borderRadius: '0px 20px 20px 0px'
                }}>
                <StyledNormalTypography
                    variant="subtitle2"
                    color={item.color}
                    sx={{ marginLeft: '10px' }}>
                    {item.title}
                </StyledNormalTypography>
                {open ? (
                    <ExpandLess sx={{ color: '#FFFFFF' }} />
                ) : (
                    <ExpandMore sx={{ color: '#FFFFFF' }} />
                )}
            </ListItem>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={{ marginTop: '5px' }}>
                    {children &&
                        children.map((child: BasketListViewModel, key: number) => (
                            <InsideMultiLevel
                                key={key}
                                item={child}
                                active={active}
                                setActive={setActive}
                            />
                        ))}
                </List>
            </Collapse>
        </>
    );
};
